import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './header/header.component';
import useAuth from '../../hooks/useAuth';

function UnauthorizedLayout() {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const { auth } = useAuth();
  return (
    <>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <AppShell
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
              '@media (max-width: 992px)': {
                paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
              },
            },
          }}
          navbarOffsetBreakpoint='md'
          asideOffsetBreakpoint='md'
          fixed
          header={<AppHeader opened={opened} setOpened={setOpened} />}
        >
          <Outlet />
        </AppShell>
      </MantineProvider>
    </>
  );
}

export default UnauthorizedLayout;
